<div class="search-suggestions" *ngIf="hasSuggestions()">
    <div class="suggestion-list">
      <ng-container *ngFor="let suggestion of suggestions; let i = index">
        <div class="suggestion-section" *ngIf="i == 0 || suggestion.mediaType != suggestions[i-1].mediaType">{{getString(suggestion.mediaType)}}</div>
        
        <a [href]="getSuggestionItemLink(suggestion)" class="suggestion">
          <img *ngIf="!suggestion.hideThumbnail" class="thumbnail" [src]="getSuggestionThumbnail(suggestion)" (error)="suggestion.hideThumbnail = true">
          <div><span class="suggestion-title">{{suggestion.title}}</span>
            <div class="smaller-gray-txt" *ngIf="suggestion.mediaType != 'apps' && suggestion.releaseYear">
              {{suggestion.releaseYear}}
            </div>
            <div class="smaller-gray-txt" *ngIf="suggestion.mediaType != 'apps'">
              {{getSuggestionActorsAndDirectors(suggestion)}}
            </div>
          </div>
        </a>
        
      </ng-container>
    </div>
    <div class="suggestion-section suggestions-footer" (click)="searchClick()">
      {{getSuggestionsSeeAllResultsText()}}
      <img *ngIf="!isDarkTheme()" [alt]="getSearchAlt()" class="magnifier-icon" src="./assets/images/flyout_lupe.png">
      <img *ngIf="isDarkTheme()" [alt]="getSearchAlt()" class="magnifier-icon" src="./assets/images/flyout_lupe_white.png">
    </div>
  </div>
